import Vue from 'vue'
import Router from 'vue-router'
import Activate from '@/views/Activate'
import CreateService from '@/views/CreateService'
import Documentation from '@/views/Documentation'
import Home from '@/views/Home'
import Login from '@/views/Login'
import NotFoundComponent from '@/views/NotFoundComponent'
import Payments from '@/views/Payments'
import PaymentOptions from '@/views/PaymentOptions'
import Profile from '@/views/Profile'
import Session from '@/api/utilities/Session'
import SetPassword from '@/views/SetPassword'
import RecoverPassword from '@/views/RecoverPassword'
import ResetPassword from '@/views/ResetPassword'
import RegisterUser from '@/views/RegisterUser'
import RegisterBusiness from '@/views/RegisterBusiness'
import RegisterComplete from '@/views/RegisterComplete'
import Visits from '@/views/Visits'
import Users from '@/views/Users'
import _ from 'lodash'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/activate/:token',
      name: 'Activate',
      component: Activate,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/set/password/:token',
      name: 'SetPassword',
      component: SetPassword,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/documentation',
      name: 'Documentation',
      component: Documentation,
      meta: {
        requiresAuth: true,
        requiresService: true
      }
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        requiresAuth: true,
        requiresService: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/payments',
      name: 'Payments',
      component: Payments,
      meta: {
        requiresAuth: true,
        requiresService: true
      }
    },
    {
      path: '/payment/options',
      name: 'PaymentOptions',
      component: PaymentOptions,
      meta: {
        requiresAuth: true,
        requiresService: true
      }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: {
        requiresAuth: true,
        requiresService: true
      }
    },
    {
      path: '/register/user',
      name: 'RegisterUser',
      component: RegisterUser,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/register/business',
      name: 'RegisterBusiness',
      component: RegisterBusiness,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/register/complete',
      name: 'RegisterComplete',
      component: RegisterComplete,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/recover/password',
      name: 'RecoverPassword',
      component: RecoverPassword,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/reset/password/:token',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/visits',
      name: 'Visits',
      component: Visits,
      meta: {
        requiresAuth: true,
        requiresService: true
      }
    },
    {
      path: '/create/service',
      name: 'CreateService',
      component: CreateService,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      meta: {
        requiresAuth: true,
        requiresService: true
      }
    },
    {
      path: '*',
      component: NotFoundComponent
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Session.has('token')) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      // Fetch the user information to feed to our user event trackers.
      const user = JSON.parse(localStorage.getItem('user'))
      // Identify a user on fresh chat
      // To set unique user id in your system when it is available
      window.fcWidget.setExternalId(user.emailAddress)
      // Set the user's basic information
      window.fcWidget.user.setFirstName(user.firstName + ' ' + user.lastName)
      window.fcWidget.user.setEmail(user.emailAddress)
      // To set user additional properties
      window.fcWidget.user.setProperties({
        clientCode: user.clientCode,
        clientName: user.clientName
      })

      // Identify a user on full story
      window.FS.identify(user.emailAddress, {
        displayName: user.firstName + ' ' + user.lastName,
        email: user.emailAddress,
        client: user.clientCode
      })

      if (to.matched.some(record => record.meta.requiresService)) {
        const services = JSON.parse(localStorage.getItem('services')) === null ? {} : JSON.parse(localStorage.getItem('services'))
        if (services.serviceDetails === undefined || _.keys(services.serviceDetails).length < 1) {
          next({
            path: '/create/service',
            query: {
              redirect: to.fullPath
            }
          })
        } else {
          next()
        }
      } else {
        next()
      }
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    if (Session.has('token')) {
      next({
        path: '/home',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js